import React, { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import { Post } from "src/services/ClientSideAPIService";
import { setCookie } from "../../helpers/Helper.js";
import { useAppContext } from "@components/Provider";

import styles from "./Login.module.css";
import "./Login.css";
import GoogleLoginButton from "@components/SocialAuth/GoogleLoginButton.js";

const Login = (props) => {
  props = props || {};
  const router = useRouter();
  const { siteId } = useAppContext();

  const [authInProgress, setAuthInProgress] = useState(false);
  const [googleAuthInProgress, setGoogleAuthInProgress] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleUserKeyPress = (event) => {
    const { which, keyCode } = event;
    if (which === 13 || keyCode === 13) {
      LoginClick();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleUserKeyPress);
    return () => {
      window.removeEventListener("keydown", handleUserKeyPress);
    };
  }, [handleUserKeyPress]);

  const LoginClick = () => {
    setAuthInProgress(true);
    if (ValidateLogin()) {
      const loginParam = {
        email: email,
        password: password,
        siteid: siteId,
      };
      Post("Login", { data: loginParam, siteid: siteId }, onSuccess, onError);
    } else {
      setAuthInProgress(false);
      setErrorMessage("Please enter username and password!");
    }
  };

  const ValidateLogin = () => {
    return email && password;
  };

  const onSuccess = (res) => {
    setAuthInProgress(false);
    setGoogleAuthInProgress(false);
    if (res.error) {
      onError(res);
    } else {
      setCookie("subscribed", email, process.env.SUBSCRIBED_COOKIE_EXPIRY_DAYS);
      setCookie("ormtoken", res.token, process.env.SUBSCRIBED_COOKIE_EXPIRY_DAYS);
      setCookie("wasloggedin", true, process.env.SUBSCRIBED_COOKIE_EXPIRY_DAYS);
      if (props.closeLoginModal && typeof props.closeLoginModal === "function") {
        props.closeLoginModal();
      }
      const redirect = props?.redirectPage || "/deals/best-ebook-deals";
      router.replace(redirect);
    }
  };

  const onError = (error) => {
    if (error) {
      let serverError = error;
      let errorMsg = serverError !== undefined ? serverError.error : "Login failed";
      setAuthInProgress(false);
      setGoogleAuthInProgress(false);

      setErrorMessage(errorMsg);
    }
  };

  const onSignUpClick = () => {
    if (props.closeLoginModal && typeof props.closeLoginModal === "function") {
      props.closeLoginModal();
    }
    router.replace("/newsletters-2");
  };

  return (
    <>
      <div className={styles.pageWrapper}>
        <div className={styles.loginBox}>
          <h2 className={styles.heading}>
            Sign In or Create
            <br />
            An Account
          </h2>

          {/* ✅ Show error message for both flows here */}
          {errorMessage ? <div className={styles.errorMsg}>{errorMessage}</div> : null}
          <div className={styles.googleButtonWrapper}>
            <GoogleLoginButton
              loading={googleAuthInProgress}
              onSuccess={({ provider, providerId, email }) => {
                setGoogleAuthInProgress(true);
                setErrorMessage("");
                const loginParam = {
                  provider,
                  providerId,
                  email,
                  siteid: siteId,
                };
                Post("Login", { data: loginParam, siteid: siteId }, onSuccess, onError);
              }}
              onError={(msg) => {
                if (msg === "access_denied") {
                  setErrorMessage("");
                } else {
                  setErrorMessage(msg);
                }
              }}
            />
          </div>

          <div className={styles.divider}>OR</div>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              LoginClick();
            }}
          >
            <label className={styles.label}>Email</label>
            <input
              type="Email"
              placeholder={props.hidePlaceHolder ? "" : "Enter your email"}
              onChange={(e) => setEmail(e.target.value)}
              name="username"
              className={styles.input}
            />

            <label className={styles.label}>Password</label>
            <input
              type="Password"
              placeholder={props.hidePlaceHolder ? "" : "Enter your password"}
              onChange={(e) => setPassword(e.target.value)}
              name="password"
              className={styles.input}
            />

            <button type="submit" className={styles.submitBtn} disabled={authInProgress}>
              {authInProgress ? "Logging in..." : props.buttonText || "Submit"}
            </button>
          </form>
        </div>
      </div>
      <div className={styles.links}>
        Don’t have an account? <a onClick={onSignUpClick}>Sign Up Here</a>
        <br />
        <a onClick={props.openForgotPasswordModal}>Forgot Password?</a>
      </div>
    </>
  );
};
export default Login;
